import { Label } from '@cian/ui-kit';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectSuburbanRkBackground, selectSuburbanRkTitle } from '../../../selectors/countryside';
import { FiltersBackgroundAdBannerContainer } from '../../../containers/FiltersBackgroundAdBannerContainer';
import { useBackgroundContext } from '../BackgroundProvider';
import defaultBackground from './assets/background.png';

import styles from './Header.css';

interface ICountrysideHeaderProps {
  /**
   * Включён ли микрофронтенд рекламного баннера (ad-banner-frontend).
   * Включён — рекламу на всю область рисует микрофронтенд поверх статичного фона.
   * Выключен — фон и лейбл управляются легаси-баннером через BackgroundProvider.
   */
  adBannerMicrofrontendEnabled?: boolean;
}

export const CountrysideHeader: FC<React.PropsWithChildren<ICountrysideHeaderProps>> = ({
  adBannerMicrofrontendEnabled = false,
  children,
}) => {
  const suburbanRkTitle = useSelector(selectSuburbanRkTitle);
  const suburbanRkBackground = useSelector(selectSuburbanRkBackground);
  const { imageUrl, defaultImageUrl, isBackgroundShown, label } = useBackgroundContext();

  // МФ: дефолтный фон шапки — кастомная картинка загородного РК либо статичный дефолт,
  // баннер (фон, пометка «Реклама», оффер) рендерит микрофронтенд отдельным слоем.
  // Легаси: фон и лейбл приходят из BackgroundProvider (управляется adfox-баннером).
  const backgroundImg = adBannerMicrofrontendEnabled
    ? suburbanRkBackground || defaultBackground
    : imageUrl || defaultImageUrl;
  const backgroundStyle =
    adBannerMicrofrontendEnabled || isBackgroundShown ? { backgroundImage: `url(${backgroundImg})` } : undefined;

  return (
    <div className={styles['header']} style={backgroundStyle} data-name="HeaderBlock">
      {adBannerMicrofrontendEnabled && (
        <div className={styles['banner-layer']}>
          <FiltersBackgroundAdBannerContainer />
        </div>
      )}
      <div className={styles['content']}>
        <div className={styles['inner']}>
          <div className={styles['title']}>{suburbanRkTitle || 'Дома, дачи и участки'}</div>
          {children}
        </div>
        {!suburbanRkTitle && <div className={styles['overlay']} />}
      </div>
      {!adBannerMicrofrontendEnabled && label && (
        <div className={styles['label']}>
          <Label>{label}</Label>
        </div>
      )}
    </div>
  );
};
